'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Caption } from '../../../server/typography/Caption/Caption';
/**
 * Compound member of <FieldSet>. Helper text below the control group.
 */
export function FieldSetDescription({ id, children }) {
    return _jsx(Caption, { id: id, children: children });
}
//# sourceMappingURL=FieldSetDescription.js.map